<template>
  <EditorLayoutSection :parentModule="parentModule"/>
</template>

<script>
  import EditorLayoutSection from '@/components/EditorLayoutSection'
  export default {
    components: {EditorLayoutSection},
    computed: {
      parentModule() {
        return 'bottomSectionModule'
      },
      topSection() {
        return this.$store.getters[`${this.parentModule}/elements`]()
      }
    },
  }
</script>